import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CHANNELS, EVENTS, handleOAuthStateRedirect } from "../../util/hub";
import { Hub } from "aws-amplify/utils";

function useOAuthRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const [redirectPath, setRedirectPath] = useState();
  const allowRedirect =
    location?.search &&
    location.search.startsWith("?code=") &&
    redirectPath &&
    location?.pathname !== redirectPath;

  useEffect(() => {
    if (allowRedirect) {
      navigate(redirectPath);
      setRedirectPath(null);
    }
  }, [allowRedirect, navigate, redirectPath]);

  useEffect(() => {
    let isMounted = true;
    const onAuthEvent = (payload) => {
      const path = handleOAuthStateRedirect(payload);
      if (!isMounted) {
        return;
      }
      if (payload?.event === EVENTS.customOAuthState && path) {
        setRedirectPath(path);
      }
    };

    const removeListener = Hub.listen(CHANNELS.auth, (data) => {
      onAuthEvent(data?.payload);
    });

    return () => {
      removeListener();
      isMounted = false;
    };
  }, [navigate]);
}
export default useOAuthRedirect;
